import React from "react";
import ReactHtmlParser from "react-html-parser";
import { MInput, ValidatedForm } from "components/forms";

import {
  payloadBuilder,
  notNullObjectBuilder,
  enrollmentService,
  networkErrorHelper,
} from "libs";

import { Row } from "design-react-kit";

export class EnrollFillAdesioniSostegnoEstero extends ValidatedForm {
  FIELDS_GROUP = [
    [
      {
        id: "istitution",
        field: "istitution",
        label:
          "Nome dell'istituzione universitaria estera che ha rilasciato il titolo sul sostegno di almeno 1500 ore e 60 CFU",
        infoText:
          "Indicare l'istituzione universitaria estera che ha rilasciato il titolo di sostegno di almeno 1500 ore e 60 CFU",
        component: MInput,
        className: "col-md-12 pt-3",
      },
    ],
    [
      {
        id: "city",
        field: "city",
        label: "Inserisci Città",
        component: MInput,
        infoText: "Città di conseguimento titolo",
        className: "col-md-12 pt-3",
      },
    ],
    [
      {
        id: "nation",
        field: "nation",
        label: "Inserisci Nazione",
        component: MInput,
        infoText: "Nazione di conseguimento titolo",
        className: "col-md-12 pt-3",
      },
    ],
    [
      {
        id: "presso",
        field: "presso",
        label: "Regione di svolgimento della prova finale",
        infoText: "Indicare la Regione di svolgimento della prova finale",
        component: MInput,
        className: "col-md-6",
      },
    ],
  ];

  ERROR_MESSAGES = {
    nation: "Valore obbligatorio",
    istitution: "Valore obbligatorio",
    city: "Valore obbligatorio",
    presso: "Valore obbligatorio",
  };

  validation = {
    nation: (value) => value !== "",
    istitution: (value) => value !== "",
    presso: (value) => value > "",
    city: (value) => value > "",
  };

  emptyFields = {
    nation: "",
    istitution: "",
    presso: "",
    city: "",
  };

  state = {
    loading: true,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
  };

  constructor(props) {
    super(props);

    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  getPayload = () => {
    const formPayload = payloadBuilder(this.state);

    const payloadQualification = [];
    payloadQualification.push({
      qualificationType: "AbilitazioneSostegnoEstero",
      template: "AbilitazioneSostegnoEstero",
      nation: formPayload.nation,
      istitution: formPayload.istitution,
      presso: formPayload.presso,
      city: formPayload.city,
    });

    return payloadQualification;
  };

  loadRemote(additionalState = {}) {
    const defaultValues = notNullObjectBuilder(this.emptyFields, {
      document: this.props.enrollData.idEnrollment,
    });

    const newState = {
      defaultValues,
      loading: false,
      ...additionalState,
    };

    this.setState(newState);
  }

  onSubmit = async () => {
    let validationSummary = "";
    let isValid = false;
    let isValidProfile = true;

    this.payload = payloadBuilder(this.state);
    let isValidForm = this.checkValidation();

    if (!isValidForm) {
      validationSummary += "<li>Inserire i campi obbligatori in rosso</li>";
    }

    // if valid call saveRemote: send data to server
    isValid = isValidProfile && isValidForm;

    if (isValid) {
      const payloadQualification = {
        idEnrollment: this.props.enrollData.idEnrollment,
        qualifications: this.getPayload(),
        currentStep: this.props.enrollData.currentStep,
      };

      try {
        // attendo la chiamata remota
        await enrollmentService.updateEnrollmentQualification(
          payloadQualification
        );
      } catch (errors) {
        validationSummary +=
          "<li>Errore imprevisto nell'invio dei dati. Se il problema persiste contattare il supporto tecnico.</li>";
        networkErrorHelper.notify(errors);
        isValid = false;
      }
    }

    // set state with validation summary
    if (validationSummary !== "") {
      validationSummary = "<ul>" + validationSummary + "</ul>";
    }
    this.setState({ validationSummary: validationSummary });

    return isValid;
  };

  saveRemote = () => {
    const validations = {
      nation: null,
      istitution: null,
      presso: null,
      city: null,
    };

    this.setState({ formActive: false, ...validations });
  };

  render() {
    const { loading, defaultValues, validationSummary } = this.state;

    if (loading) return <></>;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        <div>
          <form>{code}</form>
        </div>

        <Row>
          <div className="w-100">
            {validationSummary && (
              <div className="alert alert-danger mt-3" role="alert">
                {ReactHtmlParser(validationSummary)}
              </div>
            )}
          </div>
        </Row>
      </>
    );
  }
}
